export default "__VITE_ASSET__ChkeoNMK__"